import React from 'react';
import { GoogleMap } from '@react-google-maps/api';

import { GOOGLE_MAPS_STYLES } from '../../core/constants';
import { MapProps } from './types';

const Map: React.FunctionComponent<MapProps> = ({ center, children, radius = 1000, ...props }) => {
  const onLoad = React.useCallback(
    (map: google.maps.Map) => {
      const bounds = center ? new google.maps.Circle({ center, radius }).getBounds() : new google.maps.LatLngBounds();
      map.fitBounds(bounds as unknown as google.maps.LatLngBounds);
    },
    [center, radius]
  );

  return (
    <GoogleMap
      zoom={11}
      onLoad={onLoad}
      options={{
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        styles: GOOGLE_MAPS_STYLES,
        zoomControl: false,
      }}
      center={center}
      {...props}
    >
      {children}
    </GoogleMap>
  );
};

export default Map;
